import Link from "next/link";

import MobileClubGroup from "./mobile-club-logo-group.svg";

export const Logo = () => (
  <Link href="/">
    <a className="pt-2" aria-label="return to home">
      <MobileClubGroup />
    </a>
  </Link>
);
